import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import _ from 'lodash';

import { Header, Footer, InputField, Button } from "../../components";
import { withRedux } from "../../hoc";
import { switchLanguage } from "../../actions/language";
import { assetsPath } from "../../utils";

import {
  locationOptions,
  titleOptions,
  interestOptions,
  countryOptions
} from './options'

const { Select, Input } = InputField

const mapStateToProps = state => {
  return {
    ...state
  };
};

const actionToProps = {
  switchLanguage,
};

@withRedux(mapStateToProps, actionToProps)
export default class extends Component {
  componentDidMount() {
    this.setLanguage(this.props.match.params.language);
  }
  componentDidUpdate(prevProps) {
    const currentLanguage = prevProps.match.params.language;
    const nextLanguage = this.props.match.params.language;
    if (currentLanguage !== nextLanguage) {
      this.setLanguage(nextLanguage);
    }
  }
  setLanguage = language => {
    this.props.actions.switchLanguage(language);
  };
  handleSubmit = () => {
    console.log('handleSubmit')
  }
  render() {
    const currentLanguage = _.get(this.props, "language.currentActive");
    return (
      <div>
        <Helmet>
          <title>Laguna</title>
        </Helmet>
        <Header
          mainLogo={`${assetsPath()}/images/logo-laguna-property.svg`}
          hasSubHeader={false}
          language={currentLanguage}
        />
        <div className="main-content contact-us">
          <div className="row">
            <div className="col-xl-4 col-lg-12 order-xl-1 order-lg-2">
              <div className="address">
                <ul className="address-list">
                  <li>
                    <h3>THE LAGUNA LIFESTYLE HUB - PHUKET</h3>
                    <p>390/1 Moo 1 Srisoonthorn Road, Cherngtalay <br />Thalang, Phuket 83110 Thailand</p>
                    <p>
                      <strong>Property Sales/Resales</strong>
                      <h4>T: +66 (0)76 362 333</h4>
                      <h4>F: +66 (0)76 362 335</h4>
                      <h4>E: info@lagunaproperty.com</h4>
                    </p>
                    <p>
                      <strong>Rentals</strong>
                      <h4>T: +66 (0)76 362 333 ext. 203</h4>
                      <h4>F: +66 (0)76 362 335</h4>
                      <h4>E: rentals@lagunaproperty.com</h4>
                    </p>
                    <p>
                      <small>We will contact you within 48 hours of your inquiry submission</small>
                    </p>
                  </li>
                  <li>
                    <h3>OWNER SERVICES</h3>
                    <p>
                      Canal Village 28-29, 390/1 Moo 1, Srisoonthorn Road,
                      <br />
                      Cherngtalay, Thalang, Phuket 83110 Thailand
                    </p>
                    <p>
                      <h4>T. +66 (0)76 362 330 Ext. 2401-3</h4>
                      <h4>F. +66 (0)76 362 342</h4>
                      <h4>E. sanctuary.club@banyantree.com</h4>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-8 col-lg-12 order-xl-2 order-lg-1">
              <div className="enquiry">
                <h2>ENQUIRY</h2>
                <form className="input-field-form">
                  <div class="row">
                    <div class="col-xl-6 col-lg-12">
                      <Select options={locationOptions} />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-12">
                      <Select options={titleOptions} />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <Input placeholder="First name *" required />
                    </div>
                    <div class="col-lg-6">
                      <Input placeholder="Last name *" required />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-12">
                      <Input placeholder="Email *" required />
                    </div>
                    <div class="col-lg-6 col-md-12">
                      <Select options={interestOptions} />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-12">
                      <Input placeholder="Phone number" required />
                    </div>
                    <div class="col-lg-6 col-md-12">
                      <Input placeholder="Message" required />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-12">
                      <Select options={countryOptions} />
                    </div>
                  </div>
                  <br />
                  <br />
                  <div className="action">
                    <Button onClick={this.handleSubmit}>SEND</Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ContactUs/index.js